export default "__VITE_ASSET__DW9HHwkl__"